import { render } from "./SuccessView.vue?vue&type=template&id=2d70b317&scoped=true"
import script from "./SuccessView.vue?vue&type=script&lang=js"
export * from "./SuccessView.vue?vue&type=script&lang=js"

import "./SuccessView.vue?vue&type=style&index=0&id=2d70b317&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d70b317"]])

export default __exports__